<template>
  <div>
    <app-header></app-header>
    <div class="container-fluid">
      <div>
        <div class="row">
          <div class="col">
            <div class="display-4"><strong>{{usersettings.companyName}} - {{usersettings.firstName}} {{usersettings.lastName}}</strong></div>
          </div>
        </div>
        <hr>
      </div>
      <form @submit.prevent="useredit">
        <div class="form-row">
          <h2>User data</h2>
        </div>
        <div class="form-row">
          <div class="form-group col-md-3">
            <label class="label">Company</label>
            <input type="text" v-autofocus class="input form-control" v-model.trim="form.userCompanyName" />
          </div>
          <div class="form-group col-md-3">
            <label class="label">Language</label>
            <select class="form-control" v-model="form.userLanguage">
              <option>English</option>
              <option>Nederlands</option>
              <option>Français</option>
              <option>Deutsch</option>
              <option>Chinese</option>
              <option>Portugues</option>
              <option>Espanol</option>
              <option>Czech</option>
              <option>Polski</option>
            </select>
          </div>

          <div class="form-group col-md-3">
            <label class="label">Country</label>
            <select class="form-control" v-model="form.userCountry">
              <option>Austria</option>
              <option>Australia</option>
              <option>Belgium</option>
              <option>Canada</option>
              <option>China</option>
              <option>Croatia</option>
              <option>Czechia</option>
              <option>Denmark</option>
              <option>Finland</option>
              <option>France</option>
              <option>Germany</option>
              <option>India</option>
              <option>Iran</option>
              <option>Ireland</option>
              <option>Latvia</option>
              <option>Lithuania</option>
              <option>Luxembourg</option>
              <option>Netherlands</option>
              <option>Norway</option>
              <option>Poland</option>
              <option>Portugal</option>
              <option>Romania</option>
              <option>Russia</option>
              <option>Slovakia</option>
              <option>Spain</option>
              <option>Sweden</option>
              <option>Switzerland</option>
              <option>UK</option>
              <option>Ukraine</option>
              <option>USA</option>
            </select>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-3">
            <label class="label">First Name</label>
            <input type="text" v-autofocus class="input form-control" v-model.trim="form.userFirstName" />
          </div>
          <div class="form-group col-md-3">
            <label class="label">Last Name</label>
            <input type="text" v-autofocus class="input form-control" v-model.trim="form.userLastName" />
          </div>
        </div>
        <div v-if="role == 1">
          <div class="form-row mt-5">
            <h2>User access level</h2>
          </div>
          <div class="form-row">
            <div class="form-group col-md-3">
              <label class="label">System company</label>
              <select class="form-control" v-model="form.userSystemCompany">
                <option value="9">Aliplast</option>
                <option value="2">Reynaers</option>
                <option value="7">SAPA</option>
                <option value="1">Sobinco</option>
                <option value="8">Titon</option>
                <option value="4">VBH</option>
              </select>
            </div>
            <div class="form-group col-md-3">
              <label class="label">Role</label>
              <select class="form-control" v-model="form.userRole">
                <option value="2">Registered User</option>
                <option value="1">Sobinco Administrator</option>
                <option value="5">Sobinco Sales</option>
                <option value="6">Sobinco China</option>
                <option value="4">Reynaers Administrator</option>
                <option value="3">Unregistered User</option>
              </select>
            </div>
          </div>
        </div>
        <div class="form-row mt-5">
          <h2>User preferences</h2>
        </div>
        <div class="form-group row">
          <div class="col-md-2">
            <button class="btn btn-info" style="width:200px;" @click.stop.prevent="togglePackaging">{{packagingCaption}}</button>
          </div>
          <div v-if="form.userSetPackaging" class="col-md-2">
            <select class="form-control" v-model="form.userPackaging">
              <option value="0">Set</option>
              <option value="1">Bulk</option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-2">
            <button class="btn btn-info" style="width:200px;" @click.stop.prevent="toggleGroove">{{grooveCaption}}</button>
          </div>
          <div v-if="form.userSetGroove" class="col-md-2">
            <select class="form-control" v-model="form.userGroove">
              <option value="14">14-18</option>
              <option value="10">10-14</option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-2">
            <button class="btn btn-info" style="width:200px;" @click.stop.prevent="toggleHandleplate">{{handleplateCaption}}</button>
          </div>
          <div v-if="form.userSetHandlePlate" class="col-md-2">
            <select class="form-control" v-model="form.userHandlePlate">
              <option value="0">No</option>
              <option value="1">Yes</option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-2">
            <button class="btn btn-info" style="width:200px;" @click.stop.prevent="toggleBlock90">{{block90Caption}}</button>
          </div>
          <div v-if="form.userSetBlock90" class="col-md-2">
            <select class="form-control" v-model="form.userBlock90">
              <option value="0">No</option>
              <option value="1">Yes</option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-2">
            <button class="btn btn-info" style="width:200px;" @click.stop.prevent="toggleFCScrew">{{fcScrewCaption}}</button>
          </div>
          <div v-if="form.userSetFCScrew" class="col-md-2">
            <select class="form-control" v-model="form.userFCScrew">
              <option value="6">6 mm</option>
              <option value="12">12 mm</option>
              <option value="16">16 mm</option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-2">
            <button class="btn btn-info" style="width:200px;" @click.stop.prevent="toggleFCProfile">{{fcProfileCaption}}</button>
          </div>
          <div v-if="form.userSetFCProfile" class="col-md-2">
            <input type="number" class="input form-control form-control-sm" min="30" max="60" v-model.number="form.userFCProfile" />
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-2">
            <button class="btn btn-info" style="width:200px;" @click.stop.prevent="toggleFCCentral">{{fcCentralCaption}}</button>
          </div>
          <div v-if="form.userSetFCCentral" class="col-md-2">
            <select class="form-control" v-model="form.userFCCentral">
              <option value="0">No</option>
              <option value="1">Yes</option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-2">
            <button class="btn btn-info" style="width:200px;" @click.stop.prevent="toggleFCAdjKeeps">{{fcAdjKeepsCaption}}</button>
          </div>
          <div v-if="form.userSetFCAdjKeeps" class="col-md-2">
            <select class="form-control" v-model="form.userFCAdjKeeps">
              <option value="0">No</option>
              <option value="1">Yes</option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-2">
            <button class="btn btn-info" style="width:200px;" @click.stop.prevent="toggleFCMagnet">{{fcMagnetCaption}}</button>
          </div>
          <div v-if="form.userSetFCMagnet" class="col-md-2">
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-md-2">
            <button class="btn btn-primary mr-1" type="submit">Verzenden</button>
            <button class="btn btn-secondary" @click="cancel">Annuleren</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import AppHeader from "../intro/AppHeader";
  import store from '../../ClientApp/store';

  export default {
    data: function () {
      return {
        form: {
          userId: null,
          userCompanyName: "",
          userLanguage: "",
          userCountry: "",
          userFirstName: "",
          userLastName: "",
          userSystemCompany: null,
          userRole: null,
          userSetPackaging: null,
          userPackaging: null,
          userSetGroove: null,
          userGroove: null,
          userSetHandlePlate: null,
          userHandlePlate: null,
          userSetBlock90: null,
          userBlock90: null,
          userSetFCScrew: null,
          userFCScrew: null,
          userSetFCProfile: null,
          userFCProfile: null,
          userSetFCCentral: null,
          userFCCentral: null,
          userSetFCAdjKeeps: null,
          userFCAdjKeeps: null,
          userSetFCMagnet: null,
          userFCMagnet: null
        },
      };
    },
    components: {
      AppHeader
    },
    computed: {
      usersettings() {
        return this.$store.getters.getUserById(this.userid);
      },
      userid() {
        return this.$route.params.id;
      },
      packagingCaption() {
        return this.form.userSetPackaging ? 'Packaging On' : 'Packaging Off'
      },
      grooveCaption() {
        return this.form.userSetGroove ? 'Groove On' : 'Groove Off'
      },
      handleplateCaption() {
        return this.form.userSetHandlePlate ? 'Handle Reinforce On' : 'Handle Reinforce Off'
      },
      block90Caption() {
        return this.form.userSetBlock90 ? '90° Block On' : '90° Block Off'
      },
      fcScrewCaption() {
        return this.form.userSetFCScrew ? 'FC Bolt Screw On' : 'FC Bolt Screw Off'
      },
      fcProfileCaption() {
        return this.form.userSetFCProfile ? 'FC Profile Depth On' : 'FC Profile Depth Off'
      },
      fcCentralCaption() {
        return this.form.userSetFCCentral ? 'FC Central Lock On' : 'FC Central Lock Off'
      },
      fcAdjKeepsCaption() {
        return this.form.userSetFCAdjKeeps ? 'FC Adjustable Keeps On' : 'FC Adjustable Keeps Off'
      },
      fcMagnetCaption() {
        return this.form.userSetFCMagnet ? 'FC Magnet Show' : 'FC Magnet Hide'
      },
      role() {
        return this.$store.state.auth.role;
      },
    },
    methods: {
      useredit() {
        const payload = {
          UserId: this.userid,
          CompanyName: this.form.userCompanyName,
          SystemCompany: this.form.userSystemCompany,
          Language: this.form.userLanguage,
          FirstName: this.form.userFirstName,
          LastName: this.form.userLastName,
          Country: this.form.userCountry,
          Role: this.form.userRole,
          SetPackaging: this.form.userSetPackaging,
          Packaging: this.form.userPackaging,
          SetGroove: this.form.userSetGroove,
          Groove: this.form.userGroove,
          SetHandlePlate: this.form.userSetHandlePlate,
          HandlePlate: this.form.userHandlePlate,
          SetBlock90: this.form.userSetBlock90,
          Block90: this.form.userBlock90,
          SetFCScrew: this.form.userSetFCScrew,
          FCScrew: this.form.userFCScrew,
          SetFCProfile: this.form.userSetFCProfile,
          FCProfile: this.form.userFCProfile,
          SetFCCentral: this.form.userSetFCCentral,
          FCCentral: this.form.userFCCentral,
          SetFCAdjKeeps: this.form.userSetFCAdjKeeps,
          FCAdjKeeps: this.form.userFCAdjKeeps,
          SetFCMagnet: this.form.userSetFCMagnet,
          FCMagnet: this.form.userFCMagnet
        };

        this.$store
          .dispatch("useredit", payload)
          .then(response => {
            this.$store.dispatch("userLanguage").then(response => {
              this.$router.push("/users");
            })
          })
          .catch(error => {
            this.errors = error.data;
          });
      },
      cancel() {
        this.$router.push("/users");
      },
      togglePackaging() {
        this.form.userSetPackaging = !this.form.userSetPackaging;
      },
      toggleGroove() {
        this.form.userSetGroove = !this.form.userSetGroove;
      },
      toggleHandleplate() {
        this.form.userSetHandlePlate = !this.form.userSetHandlePlate;
      },
      toggleBlock90() {
        this.form.userSetBlock90 = !this.form.userSetBlock90;
      },
      toggleFCScrew() {
        this.form.userSetFCScrew = !this.form.userSetFCScrew;
      },
      toggleFCProfile() {
        this.form.userSetFCProfile = !this.form.userSetFCProfile;
      },
      toggleFCCentral() {
        this.form.userSetFCCentral = !this.form.userSetFCCentral;
      },
      toggleFCAdjKeeps() {
        this.form.userSetFCAdjKeeps = !this.form.userSetFCAdjKeeps;
      },
      toggleFCMagnet() {
        this.form.userSetFCMagnet = !this.form.userSetFCMagnet;
      }
    },

    mounted() {
      this.form.userCompanyName = this.usersettings.companyName;
      this.form.userLanguage = this.usersettings.language;
      this.form.userSystemCompany = this.usersettings.systemCompany;
      this.form.userFirstName = this.usersettings.firstName;
      this.form.userLastName = this.usersettings.lastName;
      this.form.userRole = this.usersettings.role;
      this.form.userCountry = this.usersettings.country;
      this.form.userSetPackaging = this.usersettings.setPackaging;
      this.form.userPackaging = this.usersettings.packaging;
      this.form.userSetGroove = this.usersettings.setGroove;
      this.form.userGroove = this.usersettings.groove;
      this.form.userSetHandlePlate = this.usersettings.setHandlePlate;
      this.form.userHandlePlate = this.usersettings.handlePlate;
      this.form.userSetBlock90 = this.usersettings.setBlock90;
      this.form.userBlock90 = this.usersettings.block90;
      this.form.userSetFCScrew = this.usersettings.setFCScrew;
      this.form.userFCScrew = this.usersettings.fcScrew;
      this.form.userSetFCProfile = this.usersettings.setFCProfile;
      this.form.userFCProfile = this.usersettings.fcProfile;
      this.form.userSetFCCentral = this.usersettings.setFCCentral;
      this.form.userFCCentral = this.usersettings.fcCentral;
      this.form.userSetFCAdjKeeps = this.usersettings.setFCAdjKeeps;
      this.form.userFCAdjKeeps = this.usersettings.fcAdjKeeps;
      this.form.userSetFCMagnet = this.usersettings.setFCMagnet;
      this.form.userFCMagnet = this.usersettings.fcMagnet;
    },
  }
</script>

<style scoped>
  @media (min-width: 1500px) {
    .container-fluid {
      width: 80%;
    }
  }

  @media (min-width: 2000px) {
    .container-fluid {
      width: 60%;
    }
  }


  .lnk {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/users/UserEdit.vue